import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

import {
  Paper,
  PaperHeadline,
  PaperContent,
  Option,
  Text,
  Select,
  Divider,
} from "../..";

import { PUBLIC_URL } from "../../constants";
// import { createArrayIncludesValueCheck } from '../../utils'

export class ByteTagsCard extends React.PureComponent {
  static ByteTagOptions = Object.freeze({
    slide: "slide",
    round: "round",
    none: "none",
  });

  static TagSizes = Object.freeze({
    small: "small/medium",
    large: "large",
  });

  static TagStyles = Object.freeze({
    black: "black",
    white: "white",
  });

  static TagTypes = Object.freeze({
    dog: 1,
    cat: 2,
  });

  static propTypes = {
    disableByteTagOptions: PropTypes.arrayOf(
      PropTypes.oneOf(Object.values(ByteTagsCard.ByteTagOptions))
    ),
    byteTagOption: PropTypes.oneOf(Object.values(ByteTagsCard.ByteTagOptions)),
    tagStyle: PropTypes.string,
    tagSize: PropTypes.string,
    tagType: PropTypes.number,
    onTagOptionChange: PropTypes.func,
    slideTagsPrice: PropTypes.string,
    roundTagsPrice: PropTypes.string,
    showSizeSelect: PropTypes.bool,
    showColorSelect: PropTypes.bool,
    showByteTagRoundOption: PropTypes.bool,
    showByteTagSlideOption: PropTypes.bool,
    banner: PropTypes.element,
    sizeSelectProps: PropTypes.shape({
      options: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.string,
          label: PropTypes.string,
        })
      ),
      value: PropTypes.string,
      onChange: PropTypes.func,
      disabled: PropTypes.bool,

      id: PropTypes.string,
    }),
    colorSelectProps: PropTypes.shape({
      options: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.string,
          label: PropTypes.string,
        })
      ),
      value: PropTypes.string,
      onChange: PropTypes.func,
      disabled: PropTypes.bool,

      id: PropTypes.string,
    }),
    // typeSelectProps: PropTypes.shape({
    //   options: PropTypes.arrayOf(
    //     PropTypes.shape({
    //       value: PropTypes.string,
    //       label: PropTypes.string,
    //     })
    //   ),
    //   value: PropTypes.string,
    //   onChange: PropTypes.func,
    //   disabled: PropTypes.bool,

    //   id: PropTypes.string,
    // }),
    id: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    refProp: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
    ]),
  };

  static defaultProps = {
    byteTagOption: ByteTagsCard.ByteTagOptions.slide,
    showSizeSelect: true,
    showColorSelect: true,
    disableByteTagOptions: [],
  };

  render() {
    const {
      // disableByteTagOptions,
      byteTagOption,
      tagSize,
      tagStyle,
      tagType,
      onTagOptionChange,
      slideTagsPrice,
      showSizeSelect,
      showColorSelect,
      roundTagsPrice,
      sizeSelectProps,
      colorSelectProps,
      showByteTagRoundOption,
      showByteTagSlideOption,
      // typeSelectProps,
      banner,
      id,
      className,
      style,
      refProp,
    } = this.props;

    const isSlideTags = byteTagOption === ByteTagsCard.ByteTagOptions.slide;

    const tagImage = getMetalTagImage(tagSize, tagStyle, tagType, isSlideTags);
    const copies = getCopies(isSlideTags);

    // const enabledOption = createArrayIncludesValueCheck(disableByteTagOptions);
    return (
      <Paper
        type={Paper.Types.framed}
        id={id}
        className={className}
        style={style}
        ref={refProp}
      >
        <PaperHeadline>Buy New Pet Tags</PaperHeadline>
        {banner}
        <PaperContent>
          <div className={cn("ui-byte-tags-card__tag-options")}>
            {showByteTagSlideOption && (<Option
              id="slide-tag-option"
              label="ByteTag Slide"
              description={
                <Text type={Text.Types.bodyBold}>{slideTagsPrice}</Text>
              }
              active={ByteTagsCard.ByteTagOptions.slide === byteTagOption}
              onClick={() =>
                onTagOptionChange(ByteTagsCard.ByteTagOptions.slide)
              }
            // disabled={!enabledOption(ByteTagsCard.ByteTagOptions.slide)}
            />)}
            {showByteTagRoundOption && (<Option
              id="round-tag-option"
              label="ByteTag Round"
              description={
                <Text type={Text.Types.bodyBold}>{roundTagsPrice}</Text>
              }
              active={ByteTagsCard.ByteTagOptions.round === byteTagOption}
              onClick={() =>
                onTagOptionChange(ByteTagsCard.ByteTagOptions.round)
              }
            // disabled={!enabledOption(ByteTagsCard.ByteTagOptions.round)}
            />)}
          </div>

          {byteTagOption !== "none" && (
            <div className={cn("ui-byte-tags-card__tag-customize")}>
              <div>
                <img
                  className={cn("ui-byte-tags-card__tag-image")}
                  // alt={`${tagShape}-${tagStyle}`}
                  src={tagImage}
                />

                {showSizeSelect && (
                  <Select
                    id="select-size-input"
                    className="ui-byte-tags-card__size-select"
                    {...sizeSelectProps}
                  />
                )}
                {tagType === '1' && showColorSelect && (
                  <>
                    <Select
                      id="select-color-input"
                      className="ui-byte-tags-card__size-select"
                      {...colorSelectProps}
                    />
                    {/* <Select 
                    id="select-size-input"
                    className="ui-byte-tags-card__size-select"
                    {...typeSelectProps}
                  />*/}
                  </>
                )}
              </div>
              <div>
                <Text type={Text.Types.headline} className={cn("ui-byte-tags-card__bytetag-heading")}>
                  ByteTag {isSlideTags ? "Slide" : "Round"}
                </Text>
                <Text type={Text.Types.bodyBold}>{copies.title}</Text>

                <ul className={cn("ui-byte-tags-card__copies__pros")}>
                  {copies.pros.map((text) => (
                    <li key={text}>{text}</li>
                  ))}
                </ul>
                <Divider></Divider>
                {showSizeSelect && (
                  <>
                    <Text type={Text.Types.bodyBold}>Sizing</Text>
                    <p>Small: 7.7cm x 1.3cm | Large: 8.1cm x 2cm</p>
                    <Divider></Divider>
                  </>
                )}
                <Text type={Text.Types.bodyBold}>Privacy Features</Text>
                <p>
                  You can choose to hide your phone number and address from your
                  pet's profile until your pet has been marked as lost.
                </p>
              </div>
            </div>
          )}
        </PaperContent>
      </Paper>
    );
  }
}

function getCopies(isSlideTagsSelected) {
  if (isSlideTagsSelected) {
    return {
      title: "Tag Features",
      pros: [
        "Made with silicone loops and a metal plate",
        "Waterproof",
        "Scratch, bite, and fade resistant",
        "Light weight and jingle free",
        "No batteries needed (ByteTag will last you decades!)",
        "Compatible with all smartphones",
        "No monthly fee",
        "Can be used anywhere and anytime",
      ],
    };
  } else {
    return {
      title: "Tag Features",
      pros: [
        "Waterproof",
        "Scratch, bite, and fade resistant",
        "Light weight and jingle free",
        "No batteries needed (ByteTag will last you decades!)",
        "Compatible with all smartphones",
        "No monthly fee",
        "Can be used anywhere and anytime",
      ],
    };
  }
}

function getMetalTagImage(
  tagSize = "large",
  tagStyle = "black",
  tagType = 1,
  isSlideTags
) {
  let result;
  tagSize = tagSize.toLowerCase();
  tagStyle = tagStyle.toLowerCase();
  if (tagStyle !== "black" && tagStyle !== "white") {
    tagStyle = "black";
  }
  tagType = parseInt(tagType);
  if (isSlideTags) {
    result = TagsImageMap["slide"][tagSize];
  } else {
    result = TagsImageMap["round"][tagStyle][tagType];
  }

  return PUBLIC_URL + result;
}

const TagsImageMap = {
  [ByteTagsCard.ByteTagOptions.slide]: {
    [ByteTagsCard.TagSizes.small]: "SlideTagSmall.jpg",
    [ByteTagsCard.TagSizes.large]: "SlideTagLarge.jpg",
  },
  [ByteTagsCard.ByteTagOptions.round]: {
    [ByteTagsCard.TagStyles.white]: {
      [ByteTagsCard.TagTypes.dog]: "RoundTagDogWhite.jpg",
      [ByteTagsCard.TagTypes.cat]: "RoundTagCatWhite.jpg",
    },
    [ByteTagsCard.TagStyles.black]: {
      [ByteTagsCard.TagTypes.dog]: "RoundTagDogBlack.jpg",
      [ByteTagsCard.TagTypes.cat]: "RoundTagCatBlack.jpg",
    },
  },
};
